import { Injectable, Type, inject } from '@angular/core';

import { EventModel } from '@frontend/sports/betting-offer/feature/model';
// It's disabled because it needs to be awaited when creating the component proxy

import { SitecoreMyBetsConfig, SportsUserSettings } from '@frontend/sports/common/client-config-data-access';
import { LoggerFactory } from '@frontend/sports/common/core/feature/logging';
import { ComponentLoaderService, ComponentProxy } from '@frontend/sports/deferred/feature/component-loader';
import { ModuleLoaderService } from '@frontend/sports/deferred/feature/module-loader';

import { MyBetsModule } from './my-bets.module';

export interface EventViewBinding {
    event: EventModel;
}

@Injectable({ providedIn: 'root' })
export class MyBetsComponentLoaderService extends ComponentLoaderService<MyBetsModule> {
    private sitecoreMyBets = inject(SitecoreMyBetsConfig);
    private userSettings = inject(SportsUserSettings);

    moduleName = 'MyBetsModule';
    private readonly myBetsAlias = 'sports-my-bets';

    constructor() {
        const moduleLoader = inject(ModuleLoaderService);
        const loggerFactory = inject(LoggerFactory);

        super(moduleLoader, loggerFactory);
    }

    getColumnViewComponent(): ComponentProxy {
        return this.getComponentProxy((module) => module.columnComponent, this.myBetsAlias, this.sitecoreMyBets, this.userSettings);
    }

    getEventViewComponent(): ComponentProxy<EventViewBinding> {
        return this.getComponentProxy<EventViewBinding>((module) => module.eventComponent, this.myBetsAlias, this.sitecoreMyBets, this.userSettings);
    }

    getModule(): Promise<Type<MyBetsModule>> {
        return import('./my-bets.module').then((m) => m.MyBetsModule);
    }
}
